import React from "react";
import Form from "./Form";
import PreviewData from "./PreviewData";

export default function Section() {
  return (
    <section>
      <Form />
      <PreviewData />
    </section>
  );
}
